exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-height .toggle-area[data-v-c5d3853a] {\n  overflow: hidden;\n  -webkit-transition: max-height 350ms ease-in-out;\n  -moz-transition: max-height 350ms ease-in-out;\n  -ms-transition: max-height 350ms ease-in-out;\n  -o-transition: max-height 350ms ease-in-out;\n  transition: max-height 350ms ease-in-out;\n}\n", ""]);

// exports
